const TOKEN_KEY = 'access_token'
const IS_AGENT_KEY = 'is_agent'
const LOGGED_ENTITY_ID = 'loggedEntityId'
const PERMISSION = 'permission'
/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
 **/
const TokenService = {
    getToken() {
        return localStorage.getItem(TOKEN_KEY)
    },

    saveToken(accessToken) {
        localStorage.setItem(TOKEN_KEY, accessToken)
    },

    removeToken() {
        localStorage.removeItem(TOKEN_KEY)
        localStorage.removeItem(IS_AGENT_KEY)
        localStorage.removeItem(LOGGED_ENTITY_ID)
    },

    saveIsAgent(isAgent) {
        localStorage.setItem(IS_AGENT_KEY, isAgent)
    },

    getIsAgent() {
        return localStorage.getItem(IS_AGENT_KEY)
    },

    SaveLoggedEntityId(loggedEntityId){
        localStorage.setItem(LOGGED_ENTITY_ID, loggedEntityId)
    },

    GetLoggedEntityId(){
        return localStorage.getItem(LOGGED_ENTITY_ID)
    },

    savePermission(permission){
        localStorage.setItem(PERMISSION, JSON.stringify(permission))
    },

    GetPermission(){
        return localStorage.getItem(PERMISSION)
    },

}

export default TokenService
